import { Component, Input } from '@angular/core';
import { IonLabel } from '@ionic/angular/standalone';

@Component({
  selector: 'lib-ion-input-fake',
  templateUrl: './ion-input-fake.component.html',
  styleUrls: ['./ion-input-fake.component.scss'],
  imports: [IonLabel],
})
export class IonInputFakeComponent {
  @Input() label = '';
  @Input() value = '';
}
